import React from 'react';
import { useDispatch } from 'react-redux';

import { MODAL_TEST_IDS } from 'apps/web_forms/utils/constants';
import { resetModal } from 'apps/web_forms/slices/appSlice';
import Modal from 'apps/web_forms/components/commons/Modal';

export const ResourceLoadingModal = () => {
  const dispatch = useDispatch();

  return (
    <Modal
      mainMessage='There are required resources loading'
      helpTip='Please wait'
      isOpen={true}
      setIsOpen={() => dispatch(resetModal())}
      icon='error'
      testId={MODAL_TEST_IDS.RESOURCE_LOADING_MODAL}
    />
  );
};
